module.exports = __webpack_public_path__ + "static/img/GD.928fd0a1.png";